import { GetStationNamesQuery } from './station_schemas'
import { DeviceTypeEnum } from '../../data/enums'
export type StationName = GetStationNamesQuery['station'][0]
export type StationNameList = GetStationNamesQuery['station']

export enum StationDirections {
    IN = 'IN',
    OUT = 'OUT'
}
export enum TrajectoryConfigurationMode {
    FilterTool = 'FilterTool',
    InlineTool = 'InlineTool'
}
type GetStationDataByNameQuery = {
    __typename?: 'query_root'
    station: Array<{
        __typename?: 'station'
        station_name: string
        lot_section_id?: string | null
        device_uuid?: string | null
        config_timestamp?: string | null
        config?: any | null
        device_direction?: string | null
        type?: DeviceTypeEnum | null
        enabled: boolean
    }>
}

export type StationDataList = GetStationDataByNameQuery['station']
export type StationData = GetStationDataByNameQuery['station'][0]
